<script>

    import { toast } from 'bulma-toast'
    import { userStore, prepaidsStore, modalStore } from '../stores'

    import PrepaidsService from '../$services/prepaids.service'
    import Providers from '../$components/providers.svelte'
    import Date from '../$components/date.svelte'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import Button from '../$components/button.svelte'

    export let type = 'global'

    let data = {}
    let loading = false

    async function createPrepaid() {

        data.userId = $userStore._id
        data.type = type

        loading = true
        const resp = await PrepaidsService.createPrepaid(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.append(resp.data)
        toast({message: 'Prepago creado', type: 'is-success'})
        
        modalStore.close()
    }
    
</script>

<Form on:submit={createPrepaid} { loading } >

    <div class="columns">
        <div class="column">
            <Providers bind:provider={data.provider} bind:service={data.service} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo (kg)" />
        </div>
        <div class="column">
            <InputText bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo (kg)" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.shipmentsTotal} label="Cantidad de guías" placeholder="Cantidad de guías" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>